/* Pinzelli : sur les fiches avec le sélecteur de packs d'origine (Signatures, Magnéclip…),
   chaque ajout au panier qui contient un cadeau (boîte, sachet…) est marqué comme un lot :
   propriétés « Lot » (nom du pack choisi) et « _pz_pack » (identifiant caché) sur toutes les lignes.
   Le panier affiche alors les pièces + le cadeau dans une seule carte, sans pouvoir changer la quantité du cadeau.
   Cadeaux en plus par palier : attribut data-pz-extra sur le bouton du palier (JSON [{ "id": variante, "until": ms }]),
   posé par snippets/pz-signatures-or.liquid (Signatures : trousse avec le 4 + 2, Pince Octobre Rose jusqu'au 31/10).
   « until » (facultatif) = date limite en millisecondes : passé cette date, le cadeau n'est plus ajouté. */
(function () {
  if (window.__pzLegacyLot) return;
  window.__pzLegacyLot = true;
  var of = window.fetch;
  var ADD = new RegExp('/cart/add(\\.js)?(\\?|$)');
  /* Suivi (07/10/2026) : Shopify émet un « product_added_to_cart » PAR LIGNE ajoutée (repris par TrackBee → AddToCart Meta,
     Klaviyo « Added to Cart », etc.). On n'envoie donc qu'1 ligne payante par l'ajout normal (= 1 événement), puis le reste
     du pack (autres coloris + cadeaux) par un fetch « discret » (iframe cachée, non observé par les pixels), envoyé en premier.
     Si le fetch discret est indisponible → ajout d'origine (tout en un) ; en cas de refus (stock…) → les lignes du pack déjà
     ajoutées sont retirées et l'erreur est renvoyée comme avant. L'événement Klaviyo est envoyé par pz-cart-events.js (global). */
  function quietFetch(url, body) {
    var f;
    try {
      f = document.createElement('iframe');
      f.setAttribute('aria-hidden', 'true'); f.tabIndex = -1; f.style.display = 'none'; f.src = 'about:blank';
      document.body.appendChild(f);
      var qf = f.contentWindow && f.contentWindow.fetch;
      if (typeof qf !== 'function') throw new Error('no quiet fetch');
    } catch (e) { if (f && f.parentNode) f.parentNode.removeChild(f); return Promise.reject(e); }
    var done = function () { setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 0); };
    var abs = /^https?:/.test(url) ? url : location.origin + (url.charAt(0) === '/' ? '' : '/') + url;
    return qf.call(f.contentWindow, abs, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { done(); return new Response(t, { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } }); }); }, function (e) { done(); throw e; });
  }
  function pzSplit(ctx, input, init2, body, pack, label, pinces) {
    var items = body.items, a = -1;
    items.forEach(function (it, i) { if (it.properties && it.properties.Lot && (a < 0 || it.quantity > items[a].quantity)) a = i; });
    window.pzLotHint = { pack: pack, label: label, pinces: pinces }; /* lu par pz-cart-events.js (événement Klaviyo unique) */
    var after = function (resp) { return resp; };
    var withBody = function (b) { var o = {}; for (var k in init2) o[k] = init2[k]; o.body = JSON.stringify(b); return o; };
    if (a < 0 || items.length < 2) return of.call(ctx, input, init2).then(after);
    var rest = {}; for (var k in body) rest[k] = body[k];
    rest.items = items.filter(function (it, i) { return i !== a; });
    var url = typeof input === 'string' ? input : (input && input.url) || '/cart/add.js';
    if (!/\.js(\?|$)/.test(url)) url = url.replace(/(\?|$)/, '.js$1');
    var dropPack = function () {
      return of.call(window, '/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var up = {}, n = 0;
        (cart.items || []).forEach(function (l) { if (l.properties && l.properties._pz_pack === pack) { up[l.key] = 0; n++; } });
        return n ? of.call(window, '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: up }) }) : null;
      }).catch(function () {});
    };
    /* 1) reste du pack en discret, 2) ligne témoin par l'ajout normal (Kaching et les pixels voient 1 ajout, panier déjà complet). */
    return quietFetch(url, { items: rest.items }).then(function (r2) {
      if (!r2.ok) return dropPack().then(function () { return r2; });
      return of.call(ctx, input, withBody({ items: [items[a]], sections: body.sections, sections_url: body.sections_url })).then(function (r1) {
        if (!r1.ok) return dropPack().then(function () { return r1; });
        return r1;
      });
    }, function () { return of.call(ctx, input, init2); }).then(after);
  }
  function extras(sel) {
    var out = [];
    try {
      var raw = sel && sel.getAttribute('data-pz-extra');
      if (!raw) return out;
      JSON.parse(raw).forEach(function (x) {
        if (x && x.id && (!x.until || Date.now() <= +x.until)) out.push(+x.id);
      });
    } catch (e) {}
    return out;
  }
  window.fetch = function (input, init) {
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      if (ADD.test(u) && init && typeof init.body === 'string' && init.body.indexOf('_pz_pack') === -1) {
        var root = document.querySelector('pinzelli-bundle');
        var body = JSON.parse(init.body);
        if (root && body && body.items && body.items.length) {
          var sel = root.querySelector('.pzb__offer.is-selected');
          var gift = +root.getAttribute('data-gift-variant') || 0;
          var more = extras(sel).filter(function (id) { return !body.items.some(function (it) { return +it.id === id; }); });
          more.forEach(function (id) { body.items.push({ id: id, quantity: 1, __pzGift: true }); });
          var hasGift = gift && body.items.length > 1 && body.items.some(function (it) { return +it.id === gift; });
          if (hasGift || more.length) {
            var label = (sel && sel.getAttribute('data-label')) || 'Pack';
            var pack = 'pzs-' + Date.now();
            body.items.forEach(function (it) {
              it.properties = it.properties || {};
              it.properties._pz_pack = pack;
              if (+it.id === gift || it.__pzGift) it.properties['Offert avec'] = label; else it.properties.Lot = label;
              delete it.__pzGift;
            });
            var init2 = {}; for (var k in init) init2[k] = init[k];
            init2.body = JSON.stringify(body);
            return pzSplit(this, input, init2, body, pack, label, +(sel && sel.getAttribute('data-quantity')) || 0);
          }
        }
      }
    } catch (e) {}
    return of.apply(this, arguments);
  };
})();
